import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import {
  GRIT_OVERLAY_SCROLL_STRATEGY_PROVIDER,
  GritOverlay,
} from './grit-overlay';
import { GritOverlayContainer } from './grit-overlay-container';
import { OverlayContentComponent } from './grit-overlay-content/grit-overlay-content.component';
import {
  GritOverlayTitleDirective,
  GritOverlayFooterDirective,
  GritOverlayCloseDirective,
} from './grit-overlay-content/grit-overlay-content-directives';
import { PgIconModule } from './../pg-icon/pg-icon.module';
import { PgButtonModule } from './../pg-button/pg-button.module';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    PgIconModule,
    PgButtonModule,
  ],
  declarations: [
    GritOverlayContainer,
    OverlayContentComponent,
    GritOverlayTitleDirective,
    GritOverlayFooterDirective,
    GritOverlayCloseDirective,
  ],
  exports: [
    GritOverlayContainer,
    OverlayContentComponent,
    GritOverlayTitleDirective,
    GritOverlayFooterDirective,
    GritOverlayCloseDirective,
  ],
  entryComponents: [GritOverlayContainer],
  providers: [GritOverlay, GRIT_OVERLAY_SCROLL_STRATEGY_PROVIDER],
})
export class GritOverlayModule {}
